<details *ngIf="environment.tools.length > 0">
  <summary>
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="row">
          <div class="col-4">
            <h6 class="link">{{ environment.name }}</h6>
          </div>
          <div class="col-8">
            <span class="tool-meta"
              ><span class="dot green"></span>{{ compat }} Compatible
              Tool(s)</span
            >
            <span class="tool-meta"
              ><span class="dot yellow"></span>{{ partial }} Partially
              Compatible Tool(s)</span
            >
            <span class="tool-meta"
              ><span class="dot red"></span>{{ incompat }} Incompatible
              Tool(s)</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p *ngIf="environment.description.length > 0" class="description">
              {{ environment.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </summary>
  <div *ngIf="environment.tools.length > 0" class="content">
    <cyborg-section class="mx-0 px-0">
      <div class="row collection-container">
        <div class="col-lg-5 content">
          <div
            *ngFor="let tool of environment.tools"
            [ngClass]="{
              selected: tool == selectedTool,
              disabled:
                tool.generatedContent?.length == 0 ||
                (tool.generatedContent?.Hunt?.length == 0 &&
                  tool.generatedContent?.Behavior?.length == 0)
            }"
            (click)="populateContent(tool)"
            class="k-hstack tools"
          >
            <img
              class="m-4"
              height="30px"
              width="30px"
              [src]="getToolIcon(tool.product)"
            />
            <div class="tool-info">
              <span class="link">{{ tool.name }}</span>
              <p
                *ngIf="
                  tool.generatedContent.Hunt?.length > 0 ||
                  tool.generatedContent.Behavior?.length > 0
                "
                class="compatibility"
              >
                {{ tool.compatible }} of
                {{
                  tool.generatedContent.Hunt?.length +
                    tool.generatedContent.Behavior?.length
                }}
                queries compatible
              </p>
              <p
                *ngIf="
                  tool.generatedContent?.length == 0 ||
                  (tool.generatedContent?.Hunt?.length == 0 &&
                    tool.generatedContent?.Behavior?.length == 0)
                "
                class="compatibility"
              >
                No content for tool
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-7 ml-auto tabs">
          <kendo-tabstrip
            [keepTabContent]="true"
            [animate]="true"
            tabAlignment="start"
            class="collections-tabs"
          >
            <kendo-tabstrip-tab
              *ngIf="
                selectedTool.generatedContent?.Hunt &&
                selectedTool.generatedContent.Hunt.length > 0
              "
              title="Hunt Queries"
              [selected]="
                selectedTool.generatedContent?.Hunt &&
                selectedTool.generatedContent.Hunt.length > 0
              "
            >
              <ng-template kendoTabContent>
                <div
                  *ngFor="let content of selectedTool.generatedContent.Hunt"
                  class="py-3 px-3"
                >
                  <div>
                    <h1 class="title">
                      <span class="badge">{{ content.goal }}</span>
                      {{ content.title }}
                    </h1>
                    <strong class="label"
                      >{{ getReadableCategory(content.category)
                      }}<span *ngIf="content.name">
                        - {{ content.name }}</span
                      ></strong
                    >
                    <i
                      style="cursor: pointer"
                      class="k-icon k-font-icon k-i-copy"
                      (click)="onCopy($event.target)"
                    ></i>
                    <a
                      *ngIf="supportedTool(selectedTool.product)"
                      class="button medium"
                      target="_blank"
                      [href]="
                        getSearchURLForContent(selectedTool, content.query)
                      "
                      >Open in {{ selectedTool.name }}</a
                    >
                    <cyborg-notice *ngIf="content.missingFields.length > 0">
                      Field mapping is missing the following field(s):
                      <span
                        *ngFor="
                          let field of content.missingFields;
                          let isLast = last
                        "
                        >{{ field }}<span>{{ isLast ? '' : ', &nbsp;' }}</span>
                      </span>
                      . Finish configuration
                      <a
                        routerLink="/settings/environment/{{
                          environment.id
                        }}/tool/{{ selectedTool.id }}"
                        >here</a
                      >
                      for full compatibility.
                    </cyborg-notice>
                    <cyborg-notice
                      *ngIf="
                        !content.matched && content.missingFields.length == 0
                      "
                    >
                      Missing mapping for
                      {{ getReadableCategory(content.category) }}. Create a
                      field mapping for this category
                      <a
                        routerLink="/settings/environment/{{
                          environment.id
                        }}/tool/{{ selectedTool.id }}"
                        >here</a
                      >.
                    </cyborg-notice>
                    <pre>{{ content.query }}</pre>
                    <div
                      *ngIf="
                        content?.deployment_requirements.searchable_data?.length
                      "
                    >
                      <strong class="label">Searchable Data</strong>
                      <p>
                        {{
                          content?.deployment_requirements.searchable_data.join(
                            ', '
                          )
                        }}
                      </p>
                    </div>
                    <div
                      *ngIf="
                        content?.deployment_requirements.deployment_steps
                          ?.length
                      "
                    >
                      <strong class="label">Deployment Steps</strong>
                      <cyborg-markdown
                        [md]="content?.deployment_requirements.deployment_steps"
                      ></cyborg-markdown>
                    </div>
                  </div>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab
              *ngIf="
                selectedTool.generatedContent?.Behavior &&
                selectedTool.generatedContent.Behavior.length > 0
              "
              title="Detection Rules"
              [selected]="
                !selectedTool.generatedContent?.Hunt ||
                !(selectedTool.generatedContent.Hunt.length > 0)
              "
            >
              <ng-template kendoTabContent>
                <div
                  *ngFor="
                    let content of selectedTool.generatedContent?.Behavior
                  "
                  class="py-3 px-3"
                >
                  <div>
                    <h1 class="title">
                      <span class="badge">{{ content.goal }}</span
                      >{{ content.title }}
                    </h1>
                    <strong class="label"
                      >{{ getReadableCategory(content.category)
                      }}<span *ngIf="content.name">
                        - {{ content.name }}</span
                      ></strong
                    >
                    <i
                      style="cursor: pointer"
                      class="k-icon k-font-icon k-i-copy"
                      (click)="onCopy($event.target)"
                    ></i>
                    <a
                      *ngIf="supportedTool(selectedTool.product)"
                      class="button medium"
                      target="_blank"
                      [href]="
                        getSearchURLForContent(selectedTool, content.query)
                      "
                      >Open in {{ selectedTool.name }}</a
                    >
                    <cyborg-notice *ngIf="content.missingFields.length > 0">
                      Field mapping is missing the following field(s):
                      <span
                        *ngFor="
                          let field of content.missingFields;
                          let isLast = last
                        "
                        >{{ field }}<span>{{ isLast ? '' : ', &nbsp;' }}</span>
                      </span>
                      . Finish configuration
                      <a
                        routerLink="/settings/environment/{{
                          environment.id
                        }}/tool/{{ selectedTool.id }}"
                        >here</a
                      >
                      for full compatibility.
                    </cyborg-notice>
                    <cyborg-notice
                      *ngIf="
                        !content.matched && content.missingFields.length == 0
                      "
                    >
                      Missing mapping for
                      {{ getReadableCategory(content.category) }}. Create a
                      field mapping for this category
                      <a
                        routerLink="/settings/environment/{{
                          environment.id
                        }}/tool/{{ selectedTool.id }}"
                        >here</a
                      >.
                    </cyborg-notice>
                    <pre>{{ content.query }}</pre>
                    <div
                      *ngIf="
                        content?.deployment_requirements.searchable_data?.length
                      "
                    >
                      <strong class="label">Searchable Data</strong>
                      <p>
                        {{
                          content?.deployment_requirements.searchable_data.join(
                            ', '
                          )
                        }}
                      </p>
                    </div>
                    <div
                      *ngIf="
                        content?.deployment_requirements.deployment_steps
                          ?.length
                      "
                    >
                      <strong class="label">Deployment Steps</strong>
                      <cyborg-markdown
                        [md]="content?.deployment_requirements.deployment_steps"
                      ></cyborg-markdown>
                    </div>
                  </div>
                </div>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
      </div>
    </cyborg-section>
  </div>
</details>
